<template>
  <div>
    <div class='xy-content-body'
      :style="{ height: '100%', width: '100%', background: '#f9f9f9' }"
      >
      <van-nav-bar style="flex:1" fixed>
        <div slot="left" @click="close">
          <van-icon name="arrow-left" color="#333" size="20" />
        </div>
        <div slot="title">
          <div class="titlediv">选择班级</div>
        </div>
      </van-nav-bar>
      <div class="popup-main">
        <div class="boxWrap">
          <div class="assessView null-data" v-if="newList.length === 0 && isLoad">
            <img src="@/assets/common/moblie-no-data.png" />
            <div>该搜索条件下暂无结果。</div>
          </div>
          <div class="class-box" v-for="(i, j) in newList" :key="j">
            <div class="grade-tit">{{gradeName}}  {{j === 0 ? 1 : newList[j-1].length}} - {{j*20 + newList[j].length}} 班</div>
            <ul class="class-list">
              <li v-for="(itm,index) in newList[j]" :key="index" :class="itm.checked ? 'onSel' : ''" @click="onSelect(itm)">
                <p>{{itm.Score}} </p>
                <p style="white-space: pre-wrap;line-height: 25px;padding: 0 10px;">{{itm.StudentOrganizationName}} </p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="sigle-bottom-btn">
        <div class="info-btn" @click="onok" v-if="list.length !== 0">确认</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
  export default {
    name: 'MoralClassList',
    data () {
      return {
        ApplicationID: 0,
        ApplicationSubMenuID: 0,
        list: [],
        newList: [],
        selectAll: [],
        schoolId: 0,
        gradeId: 0,
        gradeName: ' ',
        scoreDatas: [],
        
        isLoad: false
      }
    },
    created () {
      Toast.setDefaultOptions('loading', { duration: 0 })
      this.schoolId = this.$route.query.schoolId // 校区 id
      this.gradeId = this.$route.query.gradeId // 年级 id
      this.gradeName = this.$route.query.gradeName // 年级名
      this.ApplicationID = this.$store.state.common.menuIDs[0]
      this.ApplicationSubMenuID = this.$store.state.common.menuIDs[1]
      this.scoreDatas = this.$route.query.scoreDatas // 指标数据
      this.getClassList()
    },
    updated () {
    },
    mounted () {
      // var slide = document.querySelector('.popup-main'),
      //   nav = document.querySelector('.boxWrap'),
      //   // 开始的偏移
      //   startX = 0,
      //   // 保存的偏移
      //   translateX = 0,
      //   // 手指坐标
      //   startFinger = 0
      // var maxWidth = nav.offsetWidth - slide.offsetWidth,
      //   lastTime = 0; //按下的时间
      // slide.addEventListener('touchstart',(e) => {
      //     e.stopPropagation()
      //     startFinger = e.changedTouches[0].clientX
      //     nav.style.WebkitTransition = nav.style.transition = ''
      //     startX = translateX
      //     lastTime = Date.now()
      // })
      // slide.addEventListener('touchmove',(e) => {
      //     e.stopPropagation()
      //     var nowFinger = e.changedTouches[0].clientX,
      //         distance = nowFinger - startFinger;
      //     translateX = distance + startX
      //     // 弹性
      //     if(translateX > 0 ){ //拖动系数. 拉力的感觉
      //         translateX *= 0.4
      //     }else if( translateX < -maxWidth){  //最后.
      //         translateX = distance*0.4 + startX
      //     }
      //     shift(translateX)
      // })
      // slide.addEventListener('touchend',(e) => {
      //     var nowFinger = e.changedTouches[0].clientX,
      //         distance = nowFinger - startFinger,  //距离差
      //         timeDis = Date.now() - lastTime,  //时间差
      //         speed = (distance / timeDis)*100
      //     // 惯性
      //     translateX += speed

      //     // 边界, 弹回去
      //     if(translateX > 0){
      //         translateX = 0
      //     }else if(translateX < -maxWidth){
      //         translateX = -maxWidth
      //     }
      //     nav.style.WebkitTransition = nav.style.transition = 'transform 500ms cubic-bezier(0.1, 0.57, 0.1, 1)'
      //     shift(translateX)
      // })
      // function shift(value){
      //   nav.style.WebkitTransform = nav.style.transform = 'translateX('+value+'px)'
      // }
      
    },
    methods: {
      unloading() {
        Toast.clear()
      },
      loading() {
        Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
      },
      fail(a, b) {
        if (b) {
          Toast.success({
            message: a,
            className: 'ipad_toast',
            forbidClick: true
          })
        } else {
          Toast.fail({
            message: a,
            className: 'ipad_toast',
            forbidClick: true
          })
        }
      },
      // 获取班级
      async getClassList() {
        this.loading()
        let res = await this.xyapi.get(
          `${this.xyMApi}/eva/api/MoralScoreRecordByPad/GetMoralClassListByPad`,
          {
            SchoolDistrictID: this.schoolId,
            StudentGradeForStudentYearID: this.gradeId,
            ApplicationID: this.ApplicationID,
            ApplicationSubMenuID: this.ApplicationSubMenuID,
            Dimension: 0
          }
        )
        this.unloading()
        if (res.success) {
          this.list = res.data
          this.isLoad = true
          this.list.forEach ((item) => {
            this.$set(item, 'checked', false)
          })
          for (var i = 1; i < this.list.length/20+1; i++) {
            let list 
            list = i === 1 ? this.list.slice(0, 20) : this.list.slice((i-1)*20)
            this.newList.push(list)
          }
        }
      },
      // 保存打分
      async saveScore() {
        this.loading()
        let pickList = []
        let arr = this.selectAll.concat([])
        for (var x = 0; x < arr.length; x++) {
          for (var y = 0; y < this.scoreDatas.length; y++) {
            let aa = {}
            aa.IndexManagementID = this.scoreDatas[y].value
            aa.Score = this.scoreDatas[y].scoredefault
            // 不变的值
            aa.StudentOrganizationId = arr[x].StudentOrganizationId
            aa.AcademicYearID = arr[x].AcademicYearID
            aa.AcademicSessionID = arr[x].AcademicSessionID
            aa.AcademicSessionName = arr[x].AcademicSessionName
            aa.AcademicYearID = arr[x].AcademicYearID
            aa.AcademicYearName = arr[x].AcademicYearName
            aa.AccountID = arr[x].AccountID
            aa.Conversion = arr[x].Conversion
            aa.ConversionScore = arr[x].ConversionScore
            aa.IndicatorTypeID = arr[x].IndicatorTypeID
            aa.IsDelete = arr[x].IsDelete
            aa.LastDeleteByDate = arr[x].LastDeleteByDate
            aa.LastDeleteByID = arr[x].LastDeleteByID
            aa.ProgrammeID = arr[x].ProgrammeID
            aa.RecordDate = arr[x].RecordDate
            aa.RecordID = arr[x].RecordID
            aa.SchoolDistrictID = arr[x].SchoolDistrictID
            aa.SchoolDistrictName = arr[x].SchoolDistrictName
            aa.ScoreByID = arr[x].ScoreByID
            aa.ScoreDate = arr[x].ScoreDate
            aa.ScoreType = arr[x].ScoreType
            aa.StarScore = arr[x].StarScore
            aa.StudentGradeForStudentYearID = arr[x].StudentGradeForStudentYearID
            aa.StudentGradeID = arr[x].StudentGradeID
            aa.StudentGradeNameForStudentYearName = arr[x].StudentGradeNameForStudentYearName
            aa.StudentOrganizationId = arr[x].StudentOrganizationId
            aa.StudentOrganizationName = arr[x].StudentOrganizationName
            aa.StudentYearID = arr[x].StudentYearID
            aa.WeekDay = arr[x].WeekDay
            pickList.push(aa)
          }
        }
        let res = await this.xyapi.post(`${this.xyMApi}/eva/api/MoralScoreRecordByPad/SaveScoreRecodClassByPad`, {
          MoralEducationScoreRecordClassList: pickList
        })
        this.unloading()
        if (res.success) {
          this.fail(res.msg || '保存成功。', true)
          setTimeout(() => {
            this.close()
          }, 1000)
        }
      },
      // 确认按钮 完成评价
      onok() {
        if (this.selectAll.length !== 0) {
          this.saveScore()
        } else {
          this.fail("请先选择要评价的班级。")
        }
      },
      close() {
        this.$router.go(-1)
      },
      // 选择班级
      onSelect(item) {
        let indexs = -1
        item.checked = item.checked ? false : true
        if(item.checked){
          this.selectAll.push(item)
        }else{
          for(let i=0,len=this.selectAll.length;i<len;i++){
            if(this.selectAll[i].class ===item.class){
              indexs=i
            }
          }
        }
        if(indexs!==-1)
          this.selectAll.splice(indexs,1)
      }
    }
  }
</script>
<style lang='less' scoped>
/deep/ .van-button__text {
  font-size: 16px !important;
}
/deep/ .van-button--large {
  height: 6.6vw;
  line-height: 3.2vw;
}

.assessView {
  width: 100%;
  height: 670px;
}
.null-data {
  margin-top: 100px;
  text-align: center;
  div {
    // prettier-ignore
    font-size:18Px;
  }
}
.titlediv {
  font-size: 16px;
}
.van-nav-bar {
  height: 60px;
  line-height: 60px;
  color: #1a1a1a;
  font-weight: 500;
}
.sigle-bottom-btn {
  height: 60px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 21px 0px rgba(186, 186, 186, 0.44);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  // z-index: 99999 !important;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px 0 30px;
  .info-btn {
    width: 74px;
    height: 32px;
    background: #1677ff;
    color: #fff;
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    font-size: 14Px;
  }
}
.popup-main {
  transform: translateY(20px);
}
.boxWrap {
  overflow-x: scroll;
  white-space: nowrap;
  overflow-y: hidden;
  padding: 0 35px;
}
.class-box:nth-child(1) {
  margin-left: 20px;
}
.class-box {
  display: inline-block;
  background: #fff;
  width: 913px;
  height: 603px;
  border-radius: 2px;
  margin: 20px 20px 80px 0;
  padding: 0 10px 0 20px;
  .grade-tit {
    font-size: 15Px;
    color: rgba(0,0,0,0.85);
    line-height: 60px;
    font-weight: bold;
  }
  .class-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    li {
      width: 166px;
      height: 123px;
      border: 1px solid #d5d5d5;
      border-radius: 4px;
      margin: 0 10px 10px 0;
      text-align: center;
      line-height: 38px;
      padding: 24px 0;
      p:nth-child(1) {
        color: #E27730;
        font-size: 30px;
        font-weight: 500;
      }
      p:nth-child(2) {
        color: rgba(0,0,0,0.85);
        font-size: 16px;
      }
    }
    .onSel {
      border-color: #1677ff;
      background: url(./img/group.png) no-repeat 132px 92px;
      background-size: 63px 63px;
    }
  }
}
</style>
